<script lang="ts">
	import type { SupportedLocale } from '@viamichelin/business';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import * as m from '$paraglide/messages';
	import { contactLinkPerLocale } from './contactLink';
	import ErrorPage from './ErrorPage.svelte';

	interface Props {
		locale: SupportedLocale;
	}

	const { locale }: Props = $props();
</script>

<ErrorPage title={m.error__500__title()}>
	{m.error__500__text_start()}
	{' '}
	<span class="text-coloredneutral">
		<Link class="inline" href={contactLinkPerLocale[locale]}>
			{m.error__contact_us()}
		</Link>
	</span>
	{' '}
	{m.error__500__text_end()}
</ErrorPage>
